export const cuentasAdministracionVueltas = [
    "thomas.c@vigalab.com", 
    "nicolas.c@vigalab.com", 
    "jose.b@vigalab.com",
    "yerko.c@vigalab.com", 
    "johann.w@vigalab.com",
    "vicente.g@vigalab.com"
]